import React from 'react';
import { useTranslation } from 'react-i18next';

export const FilterSelectionBox = props => {
  const { t } = useTranslation();
  const { value, onChange, label, options, optionBlank = 'blank', blankLabel = t('filter.blankLabel'), disabled, className = '', ...restProps } = props;

  return (
    <div className={disabled ? 'filter-bar__row disabled' : 'filter-bar__row'}>
      <label
        className="filter-bar__label"
        htmlFor={label}
      >
        {label}
      </label>
      <select
        className={`filter-bar__select ${className}`}
        id={label}
        name={label}
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        {...restProps}
      >
        {blankLabel && <option value={optionBlank}>{blankLabel}</option>}
        {options?.map(option => (
          <option
            key={option.id}
            value={option.id}
          >
            {option.name ?? option.title ?? option.body}
          </option>
        ))}
      </select>
    </div>
  );
};
